"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTheme = void 0;
const initTheme = (values, defaultTextColor) => {
  const styles = {
    ...values,
    defaultText: defaultTextColor || values?.defaultText || '#000'
  };
  return styles;
};
exports.initTheme = initTheme;